import React from 'react';
import clsx from 'clsx';
import { useTheme } from '@lok/context/ThemeContext';
import { ReactComponent as DarkMoon } from '../../pages/layout/components/icons/dark-moon.svg';
import { ReactComponent as LightSun } from '../../pages/layout/components/icons/light-sun.svg';

// Light/Dark Mode row with a switch, shown in the profile menu (CON-306 header clean-up).
const ThemeSwitcher = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      type='button'
      role='menuitemcheckbox'
      aria-checked={isDarkMode}
      data-keep-menu-open
      className='flex w-full items-center justify-between gap-3 py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-green/70'
    >
      <span>Light/Dark Mode</span>
      <span
        aria-hidden='true'
        className='relative inline-flex h-6 w-11 shrink-0 items-center rounded-full bg-primary-green transition-colors'
      >
        <span
          className={clsx(
            'inline-flex h-5 w-5 items-center justify-center rounded-full bg-white shadow transition-transform',
            isDarkMode ? 'translate-x-5' : 'translate-x-0.5'
          )}
        >
          {isDarkMode ? (
            <DarkMoon className='h-3 w-3 text-primary-green' />
          ) : (
            <LightSun className='h-3 w-3 text-primary-green' />
          )}
        </span>
      </span>
    </button>
  );
};

export default ThemeSwitcher;
